import { MerchantAppReturnZodSchema } from "@redotech/redo-return-core-common/return";
import * as z from "zod";

export const getReturnsForOrder = {
  name: "getReturnsForOrder" as const,
  input: z.object({
    orderId: z.string(),
    locale: z.string().max(35).optional(),
  }),
  output: z.array(MerchantAppReturnZodSchema),
};
